import React from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { IconCompetencySolid } from '@pegasus/workforce-icons';

import { Modal, ModalFooter, ModalButton } from 'components/shared/Modal';

import './styles.scss';

interface IProfileImageUpdatedModalProps {
    handleClose: () => void;
    show: boolean;
}

export const ProfileImageUpdatedModal = ({handleClose, show}: IProfileImageUpdatedModalProps) => {
    const {t} = useTranslation();

    return (
        <Modal show={show} onHide={handleClose}>
            <div className="d-flex flex-column justify-content-center align-items-center">
                <IconCompetencySolid className="ProfileImageUpdated__checked-img text-success"/>
                <h2 className="font-weight-bold">
                    {t('common.profileImageAdded', 'Profile Image Added')}
                </h2>
                <div className="ProfileImageUpdated__explainer-text-box">
                    <Trans i18nKey="ProfileImageUpdated.ProfileImageUpdatedSuccess">
                        The profile image has now been successfully added.
                    </Trans>
                </div>
            </div>
            <ModalFooter>
                <ModalButton className="btn-xl border" variant="secondary" type="submit" onClick={() => handleClose()}>
                    {t('actions.okGreat', 'Okay, Great')}
                </ModalButton>
            </ModalFooter>
        </Modal>
    );
};
